let audioCtx = /** @type {AudioContext | null} */ (null);
let master = /** @type {GainNode | null} */ (null);
let enabled = false;
let lastDetectAt = 0;

function ensureContext() {
  if (!audioCtx) {
    audioCtx = new AudioContext();
    master = audioCtx.createGain();
    master.gain.value = 0.18;
    master.connect(audioCtx.destination);
  }
  return audioCtx;
}

/**
 * ユーザー操作に紐づけて初期化する。
 */
export async function initAudioFx() {
  const ctx = ensureContext();
  if (ctx.state !== "running") {
    await ctx.resume();
  }
  enabled = true;
}

function tone(freq, durationSec, type = "sine", gain = 0.2, when = 0) {
  if (!enabled || !audioCtx || !master) return;
  const t0 = audioCtx.currentTime + when;
  const osc = audioCtx.createOscillator();
  const g = audioCtx.createGain();
  osc.type = /** @type {OscillatorType} */ (type);
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + durationSec);
  osc.connect(g);
  g.connect(master);
  osc.start(t0);
  osc.stop(t0 + durationSec + 0.02);
}

export function playBootReadyFx() {
  tone(520, 0.09, "triangle", 0.16, 0);
  tone(780, 0.12, "triangle", 0.16, 0.08);
}

/** ブートオーバーレイ表示直後（ローディング開始） */
export function playBootLoadingOpenFx() {
  tone(340, 0.06, "sine", 0.075, 0);
  tone(480, 0.07, "triangle", 0.085, 0.062);
}

/** フェーズ移行（モデル読込開始・カメラ接続開始など） */
export function playBootPhaseTickFx() {
  tone(520, 0.03, "square", 0.05, 0);
}

/** ステップが OK になったとき（SENSORS / MODEL / CAMERA） */
export function playBootStepOkFx() {
  tone(720, 0.038, "triangle", 0.095, 0);
  tone(960, 0.048, "sine", 0.078, 0.036);
}

export function playDetectFx() {
  const now = performance.now();
  if (now - lastDetectAt < 180) return;
  lastDetectAt = now;
  tone(440, 0.045, "square", 0.06, 0);
}

export function playLockFx() {
  tone(620, 0.08, "sawtooth", 0.13, 0);
  tone(930, 0.1, "triangle", 0.12, 0.07);
}

export function playErrorFx() {
  tone(280, 0.12, "sawtooth", 0.12, 0);
  tone(220, 0.16, "sawtooth", 0.1, 0.08);
}
